import TemporaryStorageManagement from 'components/organisms/TemporaryStorageManagement';
import { AdminTemplate } from 'components/templates/AdminTemplate';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Path } from 'routes';
import { getOperatorParentBreadCrumb } from 'util/commons';
import { CustomizeItemBreadcrumbs } from 'util/Types';

const AdminSiteStorageManagement: React.FC = () => {
  const [breadcrumb, setBreadcrumb] = useState<CustomizeItemBreadcrumbs>({
    operatorName: '-',
    siteName: '-',
  });
  const { operatorId } = useParams<{
    operatorId: string;
  }>();

  return (
    <AdminTemplate
      h1="保管場所設定"
      active={getOperatorParentBreadCrumb()}
      breadcrumb={[
        {
          label: getOperatorParentBreadCrumb(),
          href: `${Path.adminOperatorListManagement}${window.location.search}`,
        },
        {
          label: breadcrumb.operatorName || '-',
          href: `${Path.adminOperatorListManagement}/${operatorId}${window.location.search}`,
        },
        {
          label: breadcrumb.siteName || '-',
        },
      ]}
    >
      <TemporaryStorageManagement
        onSetBreadcrumb={(operatorName, siteName) => {
          setBreadcrumb({
            operatorName,
            siteName,
          });
        }}
      />
    </AdminTemplate>
  );
};

export default AdminSiteStorageManagement;
